import React, { useState } from "react";
// MUI
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
// CSS
import "./modal.css";


const style = {
   position: "absolute",
   justifyContent: "center",
   top: "50%",
   left: "50%",
   transform: "translate(-50%, -50%)",
   width: "80%",
   bgcolor:  "#1f1f38",
   border: "2px solid #000",
   borderRadius: "2em",
   boxShadow: 24,
   p: 4,
   height: "auto",
   maxHeight: "80%",
   overflow: "auto"
};

// questionCheck is an Array of questions ID's to be displayed. These are the questions to be inserted into this new test.

const InformationModal = ({props}) => {
   // States for Modal opening and closing.
   const [open, setOpen] = React.useState(false);
   const handleOpen = () => setOpen(true);

  
   const handleClose = () => {
      setOpen(false);
   };



   return (
      <div>
		 <a  className="btn btn-secondary" onClick={handleOpen}>Information</a>
         <Modal className= "" open={open}>

            <Box sx={style}>
				<div className="modal-container">
					<div className="modal-header">
						<h1> {props.name}</h1>
					</div>
					
					<div className="modal-body">
							<p><b>Technologies: </b>{props.Technologies}</p>
							<p><b>Description: </b>{props.Description}</p>
							{props.LoginInfo?  <h2><b>Login Info:</b> </h2> : <h2>No Login Required!</h2>}
							{props.LoginInfo && props.LoginInfo.map((info) => 
								<div key={info.Username} className= 'login-info'>
									<h4><b>Role: {info.Role} </b></h4>	
									<p><b>Username: </b>{info.Username}</p>
									<p><b>Password: </b>{info.Password}</p>
									
								</div>
										
							
									)
							}

					</div>
					<div className="modal-footer">
						<a  className="btn btn-secondary" onClick={handleClose}>Close</a>
					</div>
					

				</div>
				
         
            </Box>
         </Modal>
      </div>
   );
};

export default InformationModal;